import { format } from 'date-fns';
import { TableColumn } from '../components/ui/NewTable';
import { ClaimProvider, ClaimProviderTable } from '../models/claimProvider';

const ClaimProvidersColumns: TableColumn<ClaimProviderTable>[] = [
  { id: 'serial', label: '#' },
  { id: 'name', label: 'Name' },
  { id: 'emails', label: 'Emails' },
  { id: 'phone', label: 'Phone' },
  { id: 'location', label: 'Location' },
  { id: 'sport', label: 'Sport' },
  { id: 'rating', label: 'Rating' },
  { id: 'reviews', label: 'Reviews' },
  { id: 'reviewStatus', label: 'Review' },
  { id: 'invitesSent', label: 'Invites' },
  { id: 'claimed', label: 'Claimed' },
  { id: 'createdAt', label: 'Created' },
];

const formatLocation = (provider: ClaimProvider) => {
  const parts = [provider.city, provider.state, provider.postalCode].filter(
    Boolean,
  );
  return parts.length ? parts.join(', ') : '-';
};

const getTableHeader = (readOnly: boolean) => {
  return readOnly
    ? ClaimProvidersColumns
    : ([
        ...ClaimProvidersColumns,
        { id: 'actions', label: 'Actions' },
      ] as TableColumn<ClaimProviderTable>[]);
};

export const ClaimProvidersToDataTable = (
  providers: ClaimProvider[],
  readOnly = false,
) => {
  const data: ClaimProviderTable[] = providers.map((provider, index) => {
    const values: ClaimProviderTable = {
      id: String(provider.id),
      serial: String(index + 1),
      name: provider.name || '-',
      emails: provider.emails?.length ? provider.emails.join(', ') : '-',
      phone: provider.phone || '-',
      location: formatLocation(provider),
      sport: provider.sportId || '-',
      rating:
        provider.rating !== null && provider.rating !== undefined
          ? String(provider.rating)
          : '-',
      reviews:
        provider.reviewsCount !== null && provider.reviewsCount !== undefined
          ? String(provider.reviewsCount)
          : '-',
      reviewStatus: provider.reviewStatus || '-',
      invitesSent: String(provider._count?.invites ?? 0),
      claimed: provider.claimed ? 'Yes' : 'No',
      createdAt: format(
        provider.createdAt ? new Date(provider.createdAt) : new Date(),
        'MM-dd-yyyy hh:mm a',
      ),
      raw: provider,
    };

    if (!readOnly) {
      values.actions = 'ACTIONS';
    }

    return values;
  });

  return {
    headers: getTableHeader(readOnly),
    data,
  };
};
